import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uerhe9978w: FaireBrandEntity = {
  token: "b_uerhe9978w",
  type: "brand",
  name: "fashionworks",
  avatarUrl:
    "https://cdn.faire.com/fastly/8e695e0e422a2ad88e547f2ba519a9bad859671f6a00f0e87f120f5c56919f95.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c522729eea38a297efddf9e7c62b4f272f04f66b9c2d2b5307fbb84e92d38f3e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8e695e0e422a2ad88e547f2ba519a9bad859671f6a00f0e87f120f5c56919f95.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c522729eea38a297efddf9e7c62b4f272f04f66b9c2d2b5307fbb84e92d38f3e.jpeg",
  location: "miami, FL, USA",
  minimumOrderDollars: 109,
  rating: 4.9,
  reviewCount: 634,
  isTopShop: true,
  isInsider: true,
  description:
    "💌Hello Friend. We're glad to share with you some details of our shop! \n\n🌸\"Fashionworks\" is not just a women's clothing store, but also a symbol of a lifestyle, a spiritual home dedicated to the pursuit of freedom and beauty. \n🌼We aim to use our brand to bring freedom, confidence, inspiration, and beauty to every woman, empowering them to become the protagonists of their own lives. \n👗Our design inspiration stems from the bohemian and western styles.\n-These designs are imbued with pure inspiration and creativity, showcasing individuality and a liberated attitude. \n\n✈️Ships from CA, USA!\n📜Just care labels in the original clothing, pls contact us when ordering if you want our brand tags to be sewn in!\n\n🔎Custom orders pls contact us!\n\n📌We want you to be thrilled with your purchase.\n-So pls feel free to contact us anytime if you have questions on your orders❗️",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:34.042Z",
    importedBy: "entity-db-cli",
  },
};
